import badminton from "./01_badminton_480_320.png";
import venteFromageVin from "./02_venteFromageVin_480x320.png";
import programme from "./05_programme_480X320.png";
import pickleball from "./06_pickleball_480X320.png";
import ecoleTennis from "./07_ecoleTennis_480X320.png";
import soireeClub from "./08_soireeClub_480x320.png";
import octobreRose from "./15-imgOctobreRose_480x320.png";

const imgAnim = [
  {
    id: 1,
    img: programme,
    title: "Programme du TCF",
    subTitle: "Découvrez toutes les animations prévues cette saison ...",
    path: "/animations/programme",
  },
  {
    id: 2,
    img: venteFromageVin,
    title: "Vente de Fromages et de Vins",
    subTitle: "Soutenez le club en passant une commande ...",
    path: "/animations/ventes",
  },
  {
    id: 3,
    img: ecoleTennis,
    title: "Fête de l'école de tennis",
    subTitle:
      "En juin participez à la fête des enfants inscrits à l'école de tennis ...",
    path: "/animations/feteecole",
  },
  {
    id: 4,
    img: soireeClub,
    title: "Soirée Club",
    subTitle: "Soirée d'été entre amis ...",
    path: "/animations/soireeclub",
  },
  {
    id: 5,
    img: badminton,
    title: "Badminton",
    subTitle: "Tournois de la Saint Patrick",
    path: "/animations/badminton",
  },
  {
    id: 6,
    img: pickleball,
    title: "Pickleball",
    subTitle: "Tournoi amical de novembre",
    path: "/animations/pickleball",
  },
  {
    id: 7,
    img: octobreRose,
    title: "Octobre Rose",
    subTitle: "Journée Octobre Rose du 19 octobre 2024",
    path: "/animations/octobrerose",
  },
];

export default imgAnim;
